import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from '@/providers/RouterShim';
import useBranches from '../../../../data/branch/useBranches';
import CreateVehiclePanel from '../../../../routes/sales-and-purchasing/Items/CreateVehiclePanel';
import { Skeleton } from '../../../../styled-components/components/Skeleton';
import { SrOnly } from '../../../../styled-components/components/SrOnly';
import { ButtonReset } from '../../../../styled-components/layout/reset';
import { IconNavMenuClose, IconNavPlus } from '../NavigationIcons';
import { useMainNavigationInitialized, useMobileMenuNavigation } from '../NavigationProvider';
import type { NavigationPage } from '../NavigationProvider/utils';
import SideNavigationLink from './SideNavigationLink';
import {
  CloseBtn,
  Footer,
  Item,
  ItemAction,
  ItemIcon,
  ItemLabel,
  ItemList,
  Wrapper,
} from './wrapper';

const ns = 'mainNavigationV2';

interface SideNavigationProps {
  externalView?: boolean;
  unknownBranch?: boolean;
  error?: boolean;
  navigationLinks: NavigationPage[];
}

const SideNavigation = ({
  externalView,
  unknownBranch,
  error,
  navigationLinks,
}: SideNavigationProps) => {
  const { branchId } = useParams<{ branchId: string }>();
  const { t } = useTranslation([ns, 'mainNavigation']);
  const [branches, requestBranches] = useBranches();
  const initialized = useMainNavigationInitialized();
  const initializing = (!branches && requestBranches.isLoading) || !initialized;
  const { onToggleMobileMenu } = useMobileMenuNavigation();

  const [createVehiclePanel, setCreateVehiclePanel] = useState(false);
  const onCloseCreateVehiclePanel = () => setCreateVehiclePanel(false);
  const onOpenCreateVehiclePanel = () => setCreateVehiclePanel(true);

  return (
    <>
      <Suspense>
        {createVehiclePanel && <CreateVehiclePanel onClose={onCloseCreateVehiclePanel} />}
      </Suspense>
      <Wrapper>
        <CloseBtn
          onClick={onToggleMobileMenu}
          title={t('closeMainNavigation', { ns: 'mainNavigation' })}
        >
          <IconNavMenuClose />
          <SrOnly>{t('closeMainNavigation', { ns: 'mainNavigation' })}</SrOnly>
        </CloseBtn>
        {!error &&
          (initializing ? (
            <ItemList>
              {[...Array(6)].map((_, index) => (
                <Item key={`itemlist-Skeleton-${index}`}>
                  <ItemIcon>
                    <Skeleton $width="24px" $height="24px" />
                  </ItemIcon>
                  <ItemLabel>
                    <Skeleton $width="52px" $height="16px" />
                  </ItemLabel>
                </Item>
              ))}
            </ItemList>
          ) : (
            !unknownBranch && (
              <ItemList>
                {navigationLinks.map((page) => (
                  <SideNavigationLink key={page.url} page={page} />
                ))}
              </ItemList>
            )
          ))}
        {false && (
          <Footer>
            <ItemList>
              {!error &&
                !externalView &&
                (initializing ? (
                  <Item>
                    <ItemIcon>
                      <Skeleton $width="40px" $height="40px" />
                    </ItemIcon>
                  </Item>
                ) : (
                  <Item
                    as={ButtonReset}
                    title={t('footer.addVehicle.displayName', { ns })}
                    disabled={!branchId}
                    onClick={onOpenCreateVehiclePanel}
                  >
                    <ItemAction>
                      <IconNavPlus />
                    </ItemAction>
                    <ItemLabel>{t('footer.addVehicle.displayName', { ns })}</ItemLabel>
                  </Item>
                ))}
            </ItemList>
          </Footer>
        )}
      </Wrapper>
    </>
  );
};

export default SideNavigation;
